/* ======================================================================
   WINKLER ART GALLERY — Photo grid lightbox (sections/wk-photo-grid.liquid)
   ----------------------------------------------------------------------
   <wk-photo-grid> custom element. Ported from the design prototype's
   inline lightbox script (.claude/design/gallery-jaffa.html ~427-444):
   click a tile to open, prev/next buttons + arrow keys to navigate
   (RTL-aware: ArrowRight goes back, like the prototype), Escape or a
   click on the backdrop to close. Follows the theme's native web
   component pattern (no framework).
   ====================================================================== */

(function () {
  "use strict";

  if (customElements.get("wk-photo-grid")) return;

  class WkPhotoGrid extends HTMLElement {
    connectedCallback() {
      this.lightbox = this.querySelector(".wk-lightbox");
      this.image = this.querySelector(".wk-lightbox__img");
      this.counter = this.querySelector(".wk-lightbox__count");
      this.tiles = Array.from(this.querySelectorAll(".wk-photo-grid__tile[data-full]"));
      if (!this.lightbox || this.tiles.length === 0) return;

      this.current = 0;
      this.onKeydown = this.onKeydown.bind(this);

      this.tiles.forEach((tile, index) => {
        tile.addEventListener("click", () => this.open(index));
      });
      this.querySelector("[data-lightbox-close]").addEventListener("click", () => this.close());
      this.querySelector("[data-lightbox-prev]").addEventListener("click", (event) => {
        event.stopPropagation();
        this.show(this.current + 1);
      });
      this.querySelector("[data-lightbox-next]").addEventListener("click", (event) => {
        event.stopPropagation();
        this.show(this.current - 1);
      });
      this.lightbox.addEventListener("click", (event) => {
        if (event.target === this.lightbox) this.close();
      });
    }

    disconnectedCallback() {
      document.removeEventListener("keydown", this.onKeydown);
    }

    show(index) {
      const count = this.tiles.length;
      this.current = (index + count) % count;
      const tile = this.tiles[this.current];
      this.image.src = tile.dataset.full;
      this.image.alt = tile.dataset.alt || "";
      this.counter.textContent = this.current + 1 + " / " + count;
    }

    open(index) {
      this.show(index);
      this.lightbox.classList.add("is-open");
      this.lightbox.setAttribute("aria-hidden", "false");
      document.documentElement.style.overflow = "hidden";
      document.addEventListener("keydown", this.onKeydown);
      this.querySelector("[data-lightbox-close]").focus();
    }

    close() {
      this.lightbox.classList.remove("is-open");
      this.lightbox.setAttribute("aria-hidden", "true");
      document.documentElement.style.overflow = "";
      document.removeEventListener("keydown", this.onKeydown);
      this.tiles[this.current].focus();
    }

    onKeydown(event) {
      if (event.key === "Escape") this.close();
      else if (event.key === "ArrowRight") this.show(this.current - 1);
      else if (event.key === "ArrowLeft") this.show(this.current + 1);
    }
  }

  customElements.define("wk-photo-grid", WkPhotoGrid);
})();
